import styled, { keyframes } from 'styled-components';

export const BlModalContainer = styled.div`

`;